import { type ReactNode } from 'react';

import { CheckIcon } from '@air/design-icons';

import { baseFiltersOptions, type FilterType } from '~/components/FiltersMenu/types';

export const getFilterProps = ({
  type,
  onSelect,
  isSelected,
  disabled,
}: {
  type: FilterType;
  onSelect: (type: FilterType) => void;
  isSelected?: boolean;
  disabled?: boolean;
}): {
  disabled?: boolean;
  id: string;
  label: string | ReactNode;
  onSelect: () => void;
  prefix?: ReactNode;
  suffix?: ReactNode;
} => {
  const Prefix = baseFiltersOptions[type].icon;

  return {
    disabled: disabled || isSelected,
    id: baseFiltersOptions[type].id,
    label: baseFiltersOptions[type].label,
    onSelect: () => onSelect(baseFiltersOptions[type].id),
    prefix: Prefix ? <Prefix className="ads:text-icon-default text-gray-10" size="sm" /> : null,
    suffix: isSelected ? <CheckIcon size="sm" className="ads:text-icon-default text-gray-10" /> : null,
  };
};
